module.exports = __webpack_public_path__ + "img/home_banner.41f030e0.png";